// @ts-nocheck: converted from JS

import Cages from '@/components/Cages/Show/Cages';
import Loading from '@/components/Loading';
import SubHeader from '@/components/UI/SubHeader';
import { _isEmpty, _notNil } from '@/littledash';
import { useLegacyApiHook } from '@/support/Hooks/api/useLegacyApiHook';
import { web as webRoute } from '@/support/route';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface RouteState {
  cageApiIds: Array<string>;
  studyId?: string;
}

const Manage = () => {
  const location = useLocation();
  const routeState = location.state as RouteState;

  // Use route state if available, otherwise fall back to session storage for backward compatibility
  const cageApiIds = routeState?.cageApiIds;
  const studyId = routeState?.studyId;
  const {
    response: cagesResponse,
    loading: cagesLoading,
    invoke: fetchCages,
  } = useLegacyApiHook({
    method: 'GET',
    apiRoute: 'cages.show',
    options: {
      invokeOnInit: false,
      onError: { slug: 'fetch-colony-cages', throw: false, toast: false },
    },
  });

  const cages = cagesResponse?.body?.data || [];

  // Hook for fetching study if we have a studyId
  const {
    response: studyResponse,
    loading: studyLoading,
    invoke: fetchStudy,
  } = useLegacyApiHook({
    method: 'GET',
    apiRoute: 'studies.show.p',
    options: {
      invokeOnInit: false,
      onError: { slug: 'fetch-study-for-colony-cages', throw: false },
    },
  });

  const study = studyResponse?.body?.data;

  useEffect(() => {
    if (!_isEmpty(cageApiIds)) {
      fetchCages({
        query: {
          sort: 'cage_order',
          order: 'asc',
          filterType: 'and',
          'filters[]': [`api_id|in|${cageApiIds.join(',')}`],
          perPage: '-1',
          include: 'counts',
        },
      });
    }
  }, [cageApiIds]);

  useEffect(() => {
    if (studyId) {
      fetchStudy({
        path: { id: studyId },
        query: {
          include: 'users,metadata,study_groups,counts',
        },
      });
    }
  }, [studyId]);

  // Simple refetch function for the Cages component
  const refetchCages = () => {
    if (!_isEmpty(cageApiIds)) {
      fetchCages({
        query: {
          sort: 'cage_order',
          order: 'asc',
          filterType: 'and',
          'filters[]': [`api_id|in|${cageApiIds.join(',')}`],
          perPage: '-1',
          include: 'counts',
        },
      });
    }
  };

  const isLoading = _isEmpty(cages) || cagesLoading || (studyLoading && _notNil(studyId));

  // Show loading if we're fetching data
  if (isLoading) {
    return (
      <>
        <SubHeader linkToText="Colony" link={webRoute('colony')} />
        <Loading />
      </>
    );
  }
  return (
    <>
      <SubHeader linkToText="Colony" link={webRoute('colony')} />
      <Cages study={study ?? null} cages={cages} fetchCages={refetchCages} inStudyView={false} />
    </>
  );
};

export default Manage;
